module.exports = __webpack_public_path__ + "img/renewable.86db6ebf.png";